import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    menuMode = 'horizontal';

    layout = 'blue';

    theme = 'blue';

    ripple = false;

    colorScheme = 'light';

    constructor(private primengConfig: PrimeNGConfig) {
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
    }

}
